import { render, staticRenderFns } from "./NavigationTabs.vue?vue&type=template&id=c5a1c968&scoped=true"
import script from "./NavigationTabs.vue?vue&type=script&lang=js"
export * from "./NavigationTabs.vue?vue&type=script&lang=js"
import style0 from "./NavigationTabs.vue?vue&type=style&index=0&id=c5a1c968&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a1c968",
  null
  
)

export default component.exports